/*
 * Responsive Image Controller
 * Provide a mechanism for loading the proper image size on document ready based on the current dimensions 
 */
var ResponsiveImageController = (function ($) {
	
	var win, body, imageSelector = ".res-img";
	
	function ready() {
		win = $(window);
		body = $(document.body);
		processImages();
		win.on('load', processImages);
		$(BreakpointController).on('crossBreakpoint', processImages);
	}
	
	function cleanBgUrl(url) {
	  var ret = url.replace(/^\s*url\(['"]?/gi, '');
	  ret = ret.replace(/['"]?\)\s*$/gi, '');
	  return ret;
	}
	
	function processImages() {
		var selector = imageSelector;
		if (typeof arguments[0] === 'string') {
			selector = arguments[0];
		}
		var imgs = $(selector);
		
		imgs.each(function () {
			var img = $(this),
				isBackground = !img.is('img'),
				desktopSrc = img.attr('data-desktop-src') || cleanBgUrl((isBackground ? img.css('background-image') : img.attr('src'))),
				desktopPosition = img.attr('data-desktop-position') || "",
				desktopSize = img.attr('data-desktop-size') || "",
				tabletSrc = img.attr('data-tablet-src') || desktopSrc, 
				tabletPosition = img.attr('data-tablet-position') || "", 
				tabletSize = img.attr('data-tablet-size') || "", 
				mobileSrc = img.attr('data-mobile-src') || tabletSrc, 
				mobilePosition = img.attr('data-mobile-position') || "", 
				mobileSize = img.attr('data-mobile-size') || "", 
				width = body.innerWidth();
				
			// Decide which image to load and load the proper src into the image.
			if (desktopSrc && (width > BreakpointController.IPAD_LANDSCAPE))  {
			  if (isBackground) {
				img.css('background-image', 'url("' + desktopSrc + '")');
				img.css('background-position', desktopPosition);
				img.css('background-size', desktopSize);
			  }
			  else {
				img[0].src = desktopSrc;  
			  }
			}
			else if (tabletSrc && (width <= BreakpointController.IPAD_LANDSCAPE && width > BreakpointController.PHONE_LANDSCAPE)) {
			  if (isBackground) {
				img.css('background-image', 'url("' + tabletSrc + '")');
				img.css('background-position', tabletPosition);
				img.css('background-size', tabletSize);
			  }
			  else {
				img[0].src = tabletSrc;  
			  }
			}
			else if (mobileSrc && (width <= BreakpointController.PHONE_LANDSCAPE)) {
			  if (isBackground) {
				img.css('background-image', 'url("' + mobileSrc + '")');
				img.css('background-position', mobilePosition);
				img.css('background-size', mobileSize);
			  }
			  else {
				img[0].src = mobileSrc;  
			  }
			}
		});
	}
	
	$(ready);
	
	// Return object representing the public API.
	return (function () {
		var ret = {
			processImages: processImages,
			cleanBgUrl: cleanBgUrl,
		};
		Object.defineProperty(ret, 'imageSelector', {
			get: function () {
				return imageSelector;
			}, 
			set: function (sel) {
				imageSelector = sel;
			}
		});
		return ret;
	})();
	
})(jQuery);
